import { render, staticRenderFns } from "./sportsItem.vue?vue&type=template&id=5dc7d9ae&lang=pug&"
import script from "./sportsItem.vue?vue&type=script&lang=js&"
export * from "./sportsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports